import { WrapperEntryName } from '@/interfaces';
import dynamic from 'next/dynamic';

export const WrapperEntryMapping: {
  [key in WrapperEntryName]?: React.ComponentType<any>;
} = {
  [WrapperEntryName.ContentItem]: dynamic(async () => import('../components/Wrapper/ContentItems')),
};
